/**
 * Scripts that run on the navigator page
 */
(
  function (window, document, $, _, undefined) {
    $(document).ready(
      function () {
        const hashLinks = $('a[href="#"]');

        if (hashLinks.length > 0) {
          hashLinks.on('click', (e) => e.preventDefault());
        }
      }
    );
  }
)(window, document, window.jQuery, window.lodash);
